import { render } from "./SzWorkflowUser.vue?vue&type=template&id=3096f36f&scoped=true"
import script from "./SzWorkflowUser.vue?vue&type=script&lang=ts"
export * from "./SzWorkflowUser.vue?vue&type=script&lang=ts"

import "./SzWorkflowUser.vue?vue&type=style&index=0&id=3096f36f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3096f36f"

export default script